import request from '@/utils/request'

// 查询公告列表分页
export function pageNotice (query) {
  return request({
    url: '/system/notice/page',
    method: 'get',
    params: query
  })
}
// 查询公告列表
export function listNotice (query) {
  return request({
    url: '/system/notice/list',
    method: 'get',
    params: query
  })
}
// 查询公告详细
export function getNotice (noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'get'
  })
}

// 查询待审核动态数量（后台铃铛角标）
export function pendingAuditCount () {
  return request({
    url: '/video/video/pendingAuditCount',
    method: 'get'
  })
}

// 查询待审核动态ID列表（后台铃铛红点标记）
export function pendingAuditIds () {
  return request({
    url: '/video/video/pendingAuditIds',
    method: 'get'
  })
}

// 查询待审核动态摘要列表（后台铃铛待办，与角标同源实时）
export function pendingAuditList () {
  return request({
    url: '/video/video/pendingAuditList',
    method: 'get'
  })
}

// 新增公告
export function addNotice (data) {
  return request({
    url: '/system/notice',
    method: 'post',
    data: data
  })
}

// 修改公告
export function updateNotice (data) {
  return request({
    url: '/system/notice',
    method: 'put',
    data: data
  })
}

// 删除公告
export function delNotice (noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'delete'
  })
}
